import React from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { AuthContext } from "../../shared/context/auth-context";
import { useHistory, useParams } from "react-router-dom";
import Card from "../../shared/components/UIElements/Card";
import Button from "../../shared/components/formElements/Button";
import Modal from "../../shared/components/UIElements/Modal";
import { useHttpClient } from "../../shared/hooks/http-hook";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import { formatPhoneNumber } from "../../print/page/Print";
import './AlterationInfo.css';
import Capitalize from "../../shared/components/UIElements/Capitalize ";

const AlterationInfo = () => {
  const auth = useContext(AuthContext);
  const history = useHistory();
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [loadedAlteration, setLoadedAlteration] = useState({
    customerName: "",
    date:"",
    description:"",
    dueDate:"",
    orderNumber:"",
    orders:[""],
    phone:"",
    salesTax:""
  });
  const alterationID = useParams().alterationId;
  useEffect(() => {
    const fetchAlterations = async () => {
      let responseData;
      try {
        responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL+`/alterations/${alterationID}`,
          'GET',
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setLoadedAlteration(responseData.alteration);
   
      } catch (err) { }
    };
    fetchAlterations();
  }, [sendRequest, alterationID, auth.token ]);

  const [showConfirmModal, setShowConfirmModal] = useState("");
  // const [showConfirmArchive, setShowConfirmArchive] = useState(false);

  const showWarningHandler = (task) => {
    setShowConfirmModal(task);
  };

  const cancelWarningHandler = () => {
    setShowConfirmModal("");
  };

  const confirmDeleteHandler = async () =>{
    setShowConfirmModal("");
    try {
      await sendRequest(process.env.REACT_APP_BACKEND_URL+`/alterations/${alterationID}`, 
      "DELETE",
      null,
      {Authorization: 'Bearer '+ auth.token});
      history.push("/alterations");
    } catch (err) {}
  }

  const confirmArchiveHandler = async () => {
    setShowConfirmModal("");
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL +
          `/alterations/${alterationID}/archive`,
        "PATCH",
        JSON.stringify({
          archive: loadedAlteration.archive,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );
      history.push("/alterations");
    } catch (err) {}
  };

  const printObj = {
    type: "alteration",
    customerName:Capitalize(loadedAlteration.customerName),
    orders: loadedAlteration.orders.flat(),
    orderNumber: loadedAlteration.orderNumber,
    dueDate: loadedAlteration.dueDate.substring(0, 10),
    date: loadedAlteration.date.substring(0, 10),
    phone: loadedAlteration.phone,
    description: loadedAlteration.description,
    salesTax:  loadedAlteration.salesTax,
  };
  
  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <Modal
        show={showConfirmModal}
        onCancel={cancelWarningHandler}
        header="Are you sure?"
        footerClass="alteration-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelWarningHandler}>
              CANCEL
            </Button>
            {showConfirmModal === "DELETE" ? 
            (<Button danger onClick={confirmDeleteHandler}>
              DELETE
            </Button>) :(
              <Button secondary onClick={confirmArchiveHandler}>
                ARCHIVE
              </Button>
            )}
          </React.Fragment>
        }
      >
        <p>
         {` Do you want to proceed and ${showConfirmModal.toLocaleLowerCase()} this alteration? Please note that
          it can't be undone thereafter.`}
        </p>
      </Modal>
    {!isLoading && loadedAlteration && (
      <div className="alterations-info-list">
        <Card className="alteration-item__content">
          <div className="container ">
            <form>
              <div className="flex justify-between">
                  </div>
                <div className=" w-100 tr">
                  <Button
                    reverse
                    to={{ pathname: `/print/${JSON.stringify(printObj)}` }}
                  >
                    🖨️
                  </Button>
                </div>
                <div className=" w-100 sales-header">
                  <h2 className="tc">Alteration Details</h2>
                </div>
              <br />
              <div className="flex justify-center">
                <div className=" w-50 mr1">
                  <label>Receipt Number</label>
                  <input
                    readOnly
                    type="text"
                    value={loadedAlteration.orderNumber}
                  />
                </div>
                <div className=" w-50  mr1">
                  <label>Start Date</label>
                  <input
                    readOnly
                    type="text"
                    value={loadedAlteration.date.substring(0, 10)}
                  />
                </div>
                <div className=" w-50  mr1">
                  <label>Due Date</label>
                  <input
                    readOnly
                    type="text"
                    value={loadedAlteration.dueDate.substring(0, 10)}
                  />
                </div>
               
              </div>

              <div className="flex justify-center">
                <div className=" w-50 mr1">
                  <label>Name</label>
                  <input
                    readOnly
                    type="text"
                    value={loadedAlteration.customerName}
                  />
                </div>

                
                <div className=" w-50  mr1">
                  <label>Phone</label>
                  <input
                    readOnly
                    type="text"
                    value={formatPhoneNumber(loadedAlteration.phone)}
                  />
                </div>
              </div>

              <div className="flex justify-center">
                <div className="db  w-100">
                  <label>Description</label>
                  <textarea                 
                    readOnly
                    value={loadedAlteration.description}
                  />
                </div>
              </div>
            </form>
          </div>

          <table className="items-table">
            <tbody>
              <tr>
                <th>Service</th>
                <th>Price</th>
              </tr>
             
              {loadedAlteration.orders.flat().map((order) => {
                return (
                  <tr key={order.style + order.price}>
                  <td>{order.style}</td>
                  <td>{"$" + order.price}</td>
                  </tr>
                );
              }
              )}
            </tbody>
          </table>
          <div className="alteration-item__actions">
            <Button inverse to="/alterations">
              BACK
            </Button>
            <Button to={`/alterations/${alterationID}/edit`}>EDIT</Button>
            <Button danger onClick={() => showWarningHandler("DELETE")}>
              DELETE
            </Button>
            <Button secondary onClick={() => showWarningHandler("ARCHIVE")}>
              
              {loadedAlteration.archive === true ? "UNARCHIVE" : "ARCHIVE"}
            </Button>
          </div>
        </Card>
      </div>
    )}
    <FloatingButton icon={"back"} />
  </React.Fragment>
);
};


export default AlterationInfo;